export const sumNum = (array: number[]) =>
  array.reduce((acc, curr) => acc + curr, 0);

export const getMinNum = (array: number[]) =>
  array.reduce((previous, current) =>
    current < previous ? current : previous
  );

export const getMaxNum = (array: number[]) =>
  array.reduce((previous, current) =>
    current > previous ? current : previous
  );

// T: generisk type, vilkårlig objekt
// Eks: sortBy({ array: [5, 1, 4, 2, 3], order: 'desc' }) => [5,4,3,2,1]
// Eks2: sortBy([{ name: 'Anne', age: 30 }, { name: 'Bob', age: 20 }],'asc', (v) => v.age)
// => [{ "name": "Bob", "age": 20}, { "name": "Anne", "age": 30}]
export const sortBy = <T>(
  // Array med objekter av typen T
  array: Array<T>,
  // Stigende (default) eller synkende sortering
  order: 'asc' | 'desc' = 'asc',
  // Funksjon som henter ut propertyverdien du vil sortere på i et objekt av typen T
  func?: (o: T) => number | string
): T[] => {
  // sort() muterer originalt objekt, lager derfor en kopi
  const newArr = [...array];
  if (func) {
    return order === 'asc'
      ? newArr.sort((a, b) =>
          func(a) === func(b) ? 0 : func(a) > func(b) ? 1 : -1
        )
      : newArr.sort((a, b) =>
          func(a) === func(b) ? 0 : func(a) > func(b) ? -1 : 1
        );
  }
  return order === 'asc'
    ? newArr.sort((a, b) => (a === b ? 0 : a > b ? 1 : -1))
    : newArr.sort((a, b) => (a === b ? 0 : a > b ? -1 : 1));
};
